<template>
  <v-row no-gutters>
    <v-col>
      <p
        class="advancedSearchLink cursorPointer"
        @click="$emit('toggleAdvanceSearch')"
        :data-test-id="`${parentDataTestId}__toggle-btn`"
      >
        <span class="font12 font700">
          {{ labelText }}
        </span>
      </p>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: 'AdvanceSearchLabel',
  props: {
    openadvanceSearch: Boolean,
    parentDataTestId: {
      required: true,
      type: String
    }
  },
  computed: {
    labelText() {
      return this.openadvanceSearch
        ? 'Close advanced search -'
        : 'Advanced Search +';
    }
  }
};
</script>
